/* eslint-disable no-unused-vars */
/* eslint-disable no-restricted-globals */
/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable react/prop-types */
import { Box, Grid, Typography } from "@mui/material";
import { Formik } from "formik";
import * as Sentry from "@sentry/react";
import React, { useContext, useState } from "react";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import dayjs from "dayjs";
import { debounce } from "../../../utils/helper";
import { AlertStatus } from "../../../contants";
import Modal from "../../../components/common/Modal/Modal";
import InputField from "../../../components/common/new/InputField/InputField";
import { CommonStyles } from "../../../components/common/Button/commonButtonStyle";
import Button from "../../../components/common/Button";
import Styles from "./styles";
import { GOHONZON_SUBMISSION } from "../../../contants/formFields";
import { ToastAlertContext } from "../../../config/providers/ToastAlert";
import Gohonzon from "../../../services/api/gohonzon";
import Dropdown from "../../../components/common/new/Dropdown/Dropdown";
// import NewOrganization from "../../../components/common/new/Modals/ForwardModal/NewOrganization";

const GOHONZON_TYPE = [
  { key: "Okataki gohonzon", value: "OKATAKI_GOHONZON" },
  { key: "Omamori gohonzon", value: "OMAMORI_GOHONZON" },
];

function GohonzonUpdateModal({ open, onClose, application, onRefresh }) {
  const [applicationDate, setApplicationDate] = useState(null);
  const [allotmentDate, setAllotmentDate] = useState(null);
  const [conferredDate, setConferredDate] = useState(null);

  const toast = useContext(ToastAlertContext);

  //   console.log("applicationDate", applicationDate);
  //   console.log("allotmentDate", allotmentDate);
  //   console.log("conferredDate", conferredDate);

  console.log("application", application);

  const submitReviewRequest = async (values) => {
    console.log("values", values);
    const data = {
      // ...values,
      applicationDate: values.appliedAt,
      allotedAt: values.allotedAt,
      allotedBy: values.allotedBy,
      conferredDate: values.conferredDate,
      conferredBy: values.conferredBy,
      remark: {
        data: {
          message: values?.remark,
          event: "Helpdesk Update",
        },
      },
    };
    try {
      await Gohonzon.gohonzonEntryUpdate(
        { ...data },
        application?.applicationId
      );
      toast.show(
        `${values.gohonzonType} Entry Updated Successfully`,
        AlertStatus.SUCCESS
      );
      setTimeout(() => {
        window.location.reload();
        onRefresh();
        onClose();
      }, 2000);
    } catch (error) {
      toast.show(error.message, AlertStatus.ERROR);
      Sentry.captureException(error);
    }
  };

  const TYPE_TO_GOHONZON_VALUE = {
    GOHONZON: "OKATAKI_GOHONZON",
    OMAMORI: "OMAMORI_GOHONZON",
  };

  return (
    <Modal open={open} onClose={onClose}>
      <div>
        <Formik
          initialValues={{
            [GOHONZON_SUBMISSION.MEMBER_NAME]: application?.membername,
            [GOHONZON_SUBMISSION.MEMBER_ID]: application?.memberId,
            // [GOHONZON_SUBMISSION.GOHONZON_TYPE]: application?.type,
            [GOHONZON_SUBMISSION.GOHONZON_TYPE]:
              TYPE_TO_GOHONZON_VALUE[application?.type] || "",
            // [GOHONZON_SUBMISSION.GOHONZON_TYPE]:
            //   application?.type === "GOHONZON"
            //     ? "OKATAKI_GOHONZON"
            //     : application?.type,
            [GOHONZON_SUBMISSION.APPLICATION_DATE]:
              application?.applicationDate,
            [GOHONZON_SUBMISSION.ALLOTED_AT]: application?.allotedAt,
            [GOHONZON_SUBMISSION.ALLOTED_BY]: application?.allotedBy,
            [GOHONZON_SUBMISSION.CONFERRED_DATE]: application?.createdAt
              ? dayjs(application.createdAt, "DD/MM/YYYY").format("YYYY-MM-DD")
              : "",
            [GOHONZON_SUBMISSION.CONFERRED_BY]: application?.conferredBy,
          }}
          enableReinitialize
          onSubmit={debounce(submitReviewRequest)}
        >
          {({ handleChange, values, handleSubmit, errors, setFieldValue }) => (
            <form onSubmit={handleSubmit}>
              <Box>
                <Typography
                  style={{
                    color: "#8C8C8C",
                    fontSize: "20px ",
                    fontWeight: "500",
                  }}
                >
                  Gohonzon Update
                </Typography>
                <Box marginTop="10px" color="#183053">
                  <Typography />
                  <Typography variant="small" weight={500} color="#183053">
                    {/* {Object?.values(userOSNames)?.join("/")} */}
                    {[
                      application?.areaName,
                      application?.zoneName,
                      application?.regionName,
                      application?.chapterName,
                      application?.districtName,
                      application?.blockName,
                    ]
                      .filter(Boolean)
                      .join("/ ")}
                  </Typography>
                </Box>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "flex-end",
                  }}
                >
                  <Grid item md={8} sm={12}>
                    <div style={{ padding: "20px 0px 0px 10px" }}>
                      <div style={{ ...Styles.gridContainer }}>
                        <div style={{ ...Styles.gridItem }}>
                          <InputField
                            label="Member Name"
                            name={GOHONZON_SUBMISSION.MEMBER_NAME}
                            value={values[GOHONZON_SUBMISSION.MEMBER_NAME]}
                            error={errors[GOHONZON_SUBMISSION.MEMBER_NAME]}
                            onChange={handleChange}
                            disabled
                          />
                        </div>
                        <div style={{ ...Styles.gridItem }}>
                          <InputField
                            label="Member Id"
                            name={GOHONZON_SUBMISSION.MEMBER_ID}
                            value={values[GOHONZON_SUBMISSION.MEMBER_ID]}
                            error={errors[GOHONZON_SUBMISSION.MEMBER_ID]}
                            onChange={handleChange}
                            disabled
                          />
                        </div>

                        <div style={{ ...Styles.gridItem }}>
                          <Dropdown
                            required
                            inputProps={{ required: true }}
                            name={GOHONZON_SUBMISSION.GOHONZON_TYPE}
                            value={values[GOHONZON_SUBMISSION.GOHONZON_TYPE]}
                            options={GOHONZON_TYPE}
                            label="Gohonzon Type"
                            onChange={handleChange}
                            showCross
                            handleClearValue={() =>
                              setFieldValue(
                                GOHONZON_SUBMISSION.GOHONZON_TYPE,
                                ""
                              )
                            }
                          />
                        </div>

                        <div style={{ ...Styles.gridItem }}>
                          <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <DatePicker
                              name={GOHONZON_SUBMISSION.APPLICATION_DATE}
                              label="Application Date"
                              inputFormat="DD/MM/YYYY"
                              maxDate={new Date()}
                              value={
                                values?.[GOHONZON_SUBMISSION.APPLICATION_DATE]
                              }
                              onChange={(newValues) => {
                                setFieldValue(
                                  [GOHONZON_SUBMISSION.APPLICATION_DATE],
                                  dayjs(newValues).format("YYYY-MM-DD")
                                );
                                setApplicationDate(
                                  new Date(
                                    new Date(newValues).getTime() +
                                      24 * 60 * 60 * 1000
                                  )
                                );
                              }}
                              renderInput={(params) => (
                                <InputField {...params} required />
                              )}
                            />
                          </LocalizationProvider>
                        </div>

                        <div style={{ ...Styles.gridItem }}>
                          <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <DatePicker
                              name={GOHONZON_SUBMISSION.ALLOTED_AT}
                              label="Allotment Date"
                              inputFormat="DD/MM/YYYY"
                              maxDate={new Date()}
                              value={values?.[GOHONZON_SUBMISSION.ALLOTED_AT]}
                              onChange={(newValues) => {
                                setFieldValue(
                                  [GOHONZON_SUBMISSION.ALLOTED_AT],
                                  dayjs(newValues).format("YYYY-MM-DD")
                                );
                                setAllotmentDate(
                                  new Date(
                                    new Date(newValues).getTime() +
                                      24 * 60 * 60 * 1000
                                  )
                                );
                              }}
                              renderInput={(params) => (
                                <InputField {...params} required />
                              )}
                            />
                          </LocalizationProvider>
                        </div>

                        <div style={{ ...Styles.gridItem }}>
                          <InputField
                            required
                            label="Alloted By"
                            name={GOHONZON_SUBMISSION.ALLOTED_BY}
                            value={values[GOHONZON_SUBMISSION.ALLOTED_BY]}
                            error={errors[GOHONZON_SUBMISSION.ALLOTED_BY]}
                            onChange={handleChange}
                          />
                        </div>

                        <div style={{ ...Styles.gridItem }}>
                          <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <DatePicker
                              name={GOHONZON_SUBMISSION.CONFERRED_DATE}
                              label="Conferred Date"
                              inputFormat="DD/MM/YYYY"
                              maxDate={new Date()}
                              value={
                                values?.[GOHONZON_SUBMISSION.CONFERRED_DATE]
                              }
                              onChange={(newValues) => {
                                setFieldValue(
                                  [GOHONZON_SUBMISSION.CONFERRED_DATE],
                                  dayjs(newValues).format("YYYY-MM-DD")
                                );
                                setConferredDate(
                                  new Date(
                                    new Date(newValues).getTime() +
                                      24 * 60 * 60 * 1000
                                  )
                                );
                              }}
                              renderInput={(params) => (
                                <InputField {...params} required />
                              )}
                            />
                          </LocalizationProvider>
                        </div>

                        <div style={{ ...Styles.gridItem }}>
                          <InputField
                            required
                            label="Conferred By"
                            name={GOHONZON_SUBMISSION.CONFERRED_BY}
                            value={values[GOHONZON_SUBMISSION.CONFERRED_BY]}
                            error={errors[GOHONZON_SUBMISSION.CONFERRED_BY]}
                            onChange={handleChange}
                          />
                        </div>
                      </div>
                    </div>
                  </Grid>
                </div>
                <Box mt={7}>
                  <InputField
                    type="text"
                    defaultValue=""
                    key="remark"
                    name={GOHONZON_SUBMISSION.REMARK}
                    label="Enter your remark here..."
                    value={values[GOHONZON_SUBMISSION.REMARK]}
                    onChange={handleChange}
                    InputProps={{ sx: { minHeight: "91px" } }}
                    style={{
                      height: 91,
                      minWidth: "330",
                      maxWidth: "400",
                      // border: "1px solid #707070",
                      borderRadius: "5px",
                    }}
                  />
                </Box>
                <div
                  style={{
                    display: "flex",
                    gap: 5,
                    padding: "10px 0px 0px 10px",
                  }}
                >
                  <Button
                    variant="contained"
                    style={CommonStyles.buttonStyle}
                    type="submit"
                    label="Submit"
                  />
                  <Button
                    variant="outlined"
                    style={{
                      ...CommonStyles.buttonStyle,
                      marginLeft: "20px",
                    }}
                    onClick={onClose}
                    label="CANCEL"
                  />
                </div>
              </Box>
            </form>
          )}
        </Formik>
      </div>
    </Modal>
  );
}

export default GohonzonUpdateModal;
